import React from 'react'
import styled from 'styled-components'

export interface ProgressBarStat {
  value: number
  color: string
  label: string
  percentage: number
}

export interface PixelProgressBarProps {
  stats: ProgressBarStat[]
  tooltipFormatter?: (stat: ProgressBarStat) => string
  width?: string
  height?: string
}

const ProgressBarContainer = styled.div<{ width?: string; height?: string }>`
  display: flex;
  width: ${(props) => props.width || '200px'};
  height: ${(props) => props.height || '8px'};
  border-radius: 4px;
  overflow: hidden;
`

const ProgressBarSegment = styled.div<{ color: string; width: string }>`
  height: 100%;
  background-color: ${(props) => props.color};
  width: ${(props) => props.width};
  transition: width 0.3s ease;
`

export const PixelProgressBar: React.FC<PixelProgressBarProps> = ({
  stats,
  tooltipFormatter,
  width,
  height,
}) => {
  return (
    <ProgressBarContainer width={width} height={height}>
      {stats.map((stat, index) => (
        <ProgressBarSegment
          key={index}
          color={stat.color}
          width={`${stat.percentage}%`}
          title={
            tooltipFormatter
              ? tooltipFormatter(stat)
              : `${stat.value} ${stat.label}`
          }
        />
      ))}
    </ProgressBarContainer>
  )
}
